export default __webpack_public_path__ + "static/media/video-inpainting-challenge.57674657.png";